export interface BlokItem {
  cached_url?: string,
  linktype?: string,
  anchor?: string,
}

export const useGetInternalLinkFromUrl = (link: string) => {
  try {
    link = new URL(link).pathname
  } catch {
    if (!import.meta.server && window?.location?.search?.includes('_storyblok')) {
      alert(
        `Dieser auf der Seite angegebene Link aus der Seite ist ungültig und sollte gefixed werden: ${link}`,
      )
    }
  }
  return link
}

export const useCalcedLink = (item: { link?: BlokItem }) => {
  if (!item.link?.cached_url) {
    return undefined
  }

  let link = item.link.cached_url
  if (item.link.linktype === 'story') {
    link = useGetInternalLinkFromUrl(link)
  } else if (item.link.linktype === 'asset') {
    link = (link || '').replace('//a.storyblok.com', '//assets.pflege.de')
  }

  if (item.link.anchor) {
    link += `#${item.link.anchor}`
  }
  return link
}

export const useCalcedLinkHeaderLogo = (link: BlokItem) => {
  if (!link?.cached_url) {
    return null
  }

  let tempLink = link.cached_url
  if (link.linktype === 'story') {
    tempLink = useGetInternalLinkFromUrl(tempLink)
  } else if (link.linktype === 'asset') {
    tempLink = (tempLink ?? '').replace('//a.storyblok.com', '//assets.pflege.de')
  }

  if (link.anchor) {
    tempLink += `#${link.anchor}`
  }
  return tempLink
}
